import * as z from "zod/v4";

export const printDocumentScanShortcutSchema = z.object({
  printLabel: z.boolean(),
  printPackingSlip: z.boolean(),
  printPickList: z.boolean(),
  printPersonalizedSlip: z.boolean(),
});
export type PrintDocumentScanShortcut = z.infer<
  typeof printDocumentScanShortcutSchema
>;

export const printDocumentScanShortcutDisplayNames: Record<
  keyof PrintDocumentScanShortcut,
  string
> = {
  printLabel: "Print label",
  printPackingSlip: "Print packing slip",
  printPickList: "Print pick list",
  printPersonalizedSlip: "Print personalized slip",
};

export const weightScanShortcutSchema = z.object({
  focusInput: z.boolean(),
  readFromScale: z.boolean(),
});
export type WeightScanShortcut = z.infer<typeof weightScanShortcutSchema>;
export const weightScanShortcutDisplayNames: Record<
  keyof WeightScanShortcut,
  string
> = { focusInput: "Focus input", readFromScale: "Read from scale" };

export interface BarcodeProps {
  hotkey: string;
  title: string;
}

export const printHotkeyBinds: Record<keyof PrintDocumentScanShortcut, string> =
  {
    printLabel: "p",
    printPackingSlip: "s",
    printPickList: "l",
    printPersonalizedSlip: "z",
  };

export const weightScanHotkeyBinds: Record<keyof WeightScanShortcut, string> = {
  focusInput: "i",
  readFromScale: "r",
};

function getHotkey(key: string) {
  return `⌘${key.toUpperCase()}`;
}

export const printHotkeys: Record<
  keyof PrintDocumentScanShortcut,
  BarcodeProps
> = {
  printLabel: {
    title: printDocumentScanShortcutDisplayNames.printLabel,
    hotkey: getHotkey(printHotkeyBinds.printLabel),
  },
  printPackingSlip: {
    title: printDocumentScanShortcutDisplayNames.printPackingSlip,
    hotkey: getHotkey(printHotkeyBinds.printPackingSlip),
  },
  printPickList: {
    title: printDocumentScanShortcutDisplayNames.printPickList,
    hotkey: getHotkey(printHotkeyBinds.printPickList),
  },
  printPersonalizedSlip: {
    title: printDocumentScanShortcutDisplayNames.printPersonalizedSlip,
    hotkey: getHotkey(printHotkeyBinds.printPersonalizedSlip),
  },
};

export const weightScanHotkeys: Record<keyof WeightScanShortcut, BarcodeProps> =
  {
    focusInput: {
      title: weightScanShortcutDisplayNames.focusInput,
      hotkey: getHotkey(weightScanHotkeyBinds.focusInput),
    },
    readFromScale: {
      title: weightScanShortcutDisplayNames.readFromScale,
      hotkey: getHotkey(weightScanHotkeyBinds.readFromScale),
    },
  };
